module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-26.189935c3.jpg";